import { Controller } from "stimulus"
import {swissAmount} from '../src/javascripts/currency_format'
import PinchZoom from "pinch-zoom-js"
import Gesture from 'tinygesture';

export default class extends Controller {

  static targets = [ "image", "productPicture", "productPictureDescription", "productPictureWrapper", "productPictureThumbnails", "image_left_icon", "image_zoom_icon", "image_right_icon", "inputUuid", "colorVariant", "sizeVariant", "buttonAddToCart", "price", "itemStock", "spanPriceWithVat", "tabs", "tabsContent", "bullets", "productVideoWrapper", "m2Quantity", "packageQuantity", "packagePriceTotal", "selectedQuantityPrice", "cartModal", "modalTitle", "modalViewButton", "modalItemImage", "modalItemName", "modalItemSku", "modalM2Quantity", "modalPricePerM2", "modalTotalPrice" ]

  static values = {
    unitSteps: Number,
    itemId: String,
    itemName: String,
    price: Number,
    currency: String,
    currencyFormat: String,
    currencyAbbr: String
  }

  initialize() {
    this.locale = this.element.getAttribute("data-locale");
    if(!this.locale) {
      this.locale = document.querySelector("meta[name='locale']").getAttribute('content');
    }

    this.currency = document.querySelector("meta[name='currency']").getAttribute('content');
  }

  connect() {
    let li = this.tabsTarget.querySelector("li:not(.is-hidden)");
    if(li) {
      li.classList.add('is-active');
      let tab = this.tabsContentTarget.querySelector(`div#${li.children[0].dataset.target}.tab-content`);
      if(tab) {
        tab.classList.remove('is-hidden');
      }
    }

    setTimeout( () => {
      let div = this.imageTarget.parentNode.parentNode;
      div.setAttribute("data-height", div.offsetHeight);
    }, 500)

    const gesture = new Gesture(this.imageTarget, {
      diagonalSwipes: false
    });
    gesture.on('swiperight', (event) => {
      this.previewImageNavigation("right");
    });
    gesture.on('swipeleft', (event) => {
      this.previewImageNavigation("left");
    });

    if(this.unitStepsValue) {
      let inp = document.querySelector("input#item_quantity");
      if(inp) {
        inp.value = this.unitStepsValue;
        inp.setAttribute("min", this.unitStepsValue);
        inp.setAttribute("steps", this.unitStepsValue);
      }
    }

    if(this.hasM2QuantityTarget) {
      this.autoSizeInput(this.m2QuantityTarget);
    }
    if(this.hasPackageQuantityTarget) {
      this.autoSizeInput(this.packageQuantityTarget);
    }
  }

  imageNavigation() {
    let active = parseInt(this.productPictureThumbnailsTarget.dataset.active);
    let total = parseInt(this.productPictureThumbnailsTarget.dataset.thumbnails);
    let thumbnails = this.productPictureThumbnailsTarget.querySelectorAll('img');
    let keycode = event.keyCode;
    if(event.keyCode) {
      keycode = event.keyCode;
    } else {
      if(event.target.dataset.direction) {
        if(event.target.dataset.direction == 'left') {
          keycode = 37;
        } else {
          keycode = 39;
        }
      }
    }

    switch (keycode) {
      case 27:
        this.productPictureWrapperTarget.classList.add('is-hidden');

        let iframe = this.productPictureWrapperTarget.querySelector("iframe");
        if(iframe) {
          iframe.remove();
        }
        let video = this.productPictureWrapperTarget.querySelector("video");
        if(video) {
          video.remove();
        }

        break;
      case 39:
        //right
        this.pictureNavigation("left")
        break;
      case 37:
        //left
        this.pictureNavigation("right")
        break;
    }
  }

  pictureNavigation(direction) {
    let active = parseInt(this.productPictureThumbnailsTarget.dataset.active);
    let total = parseInt(this.productPictureThumbnailsTarget.dataset.thumbnails);
    let thumbnails = this.productPictureThumbnailsTarget.querySelectorAll('img');
    if(direction == "left") {
      thumbnails[active].classList.remove('active');
      if(active < total-1) {
        active++;
      } else {
        active = 0;
      }
      this.productPictureThumbnailsTarget.setAttribute("data-active", active);
      thumbnails[active].classList.add('active');
    } else {
      thumbnails[active].classList.remove('active');
      if(active > 0) {
        active--;
      } else {
        active = total-1;
      }
      this.productPictureThumbnailsTarget.setAttribute("data-active", active);
      thumbnails[active].classList.add('active');
    }

    let iframe = this.productPictureWrapperTarget.querySelector("iframe");
    if(iframe) {
      iframe.remove();
    }
    let video = this.productPictureWrapperTarget.querySelector("video");
    if(video) {
      video.remove();
    }

    this.productVideoWrapperTarget.style.display = "block"
    this.productVideoWrapperTarget.style.justifyContent = "unset"

    if(thumbnails[active].dataset.videoUrl || thumbnails[active].dataset.video) {
      this.productPictureTarget.classList.add('is-hidden');

      let div = this.productPictureTarget.parentNode;
      if(thumbnails[active].dataset.videoUrl) {
        let iframe = document.createElement('iframe');
        iframe.src = thumbnails[active].dataset.videoUrl;
        iframe.title = thumbnails[active].dataset.name;
        iframe.frameborder = "0"
        iframe.style.margin = "auto"
        iframe.style.width = "100%"
        iframe.style.height = "60vh";
        this.productPictureDescriptionTarget.textContent = thumbnails[active].alt;
        div.appendChild(iframe);
      } else {
        let video = document.createElement('video');
        video.controls = true;
        video.setAttribute('controlsList', 'nodownload')
        video.src = thumbnails[active].dataset.video;
        this.productPictureDescriptionTarget.textContent = thumbnails[active].alt;

        this.productVideoWrapperTarget.style.display = "flex"
        this.productVideoWrapperTarget.style.justifyContent = "center"
        div.appendChild(video);
      }
    } else {
      this.productPictureTarget.classList.remove('is-hidden');
      this.imageTarget.removeAttribute('data-video-url');

      this.productPictureTarget.src = thumbnails[active].dataset.image;
      this.productPictureDescriptionTarget.textContent = thumbnails[active].alt;
    }
  }

  previewNavigation() {
    if(event.detail > 1) {
      event.preventDefault();
    }

    if(event.target.dataset.direction) {
      if(event.target.dataset.direction == 'left') {
        this.previewImageNavigation("right")
      } else {
        this.previewImageNavigation("left")
      }
    }
    if(document.selection && document.selection.empty) {
        document.selection.empty();
    } else if(window.getSelection) {
        var sel = window.getSelection();
        sel.removeAllRanges();
    }
  }

  previewImageNavigation(direction) {
    let total = parseInt(this.productPictureThumbnailsTarget.dataset.thumbnails);
    let active = parseInt(this.productPictureThumbnailsTarget.dataset.active);
    let thumbnails = this.productPictureThumbnailsTarget.querySelectorAll('img');
    let bullets = this.bulletsTarget.querySelectorAll("div");

    thumbnails[active].classList.remove('active');
    bullets[active].querySelector('svg').setAttribute("data-prefix", 'far');

    if(direction == 'left') {
      if(active < total-1) {
        active++;
      } else {
        active = 0;
      }
    } else {
      if(active > 0) {
        active--;
      } else {
        active = total-1;
      }
    }

    this.productVideoWrapperTarget.style.display = "block"
    this.productVideoWrapperTarget.style.justifyContent = "unset"

    if(thumbnails[active].dataset.videoUrl || thumbnails[active].dataset.video) {
      this.productPictureTarget.classList.add('is-hidden');
      if(thumbnails[active].dataset.videoUrl) {
        this.imageTarget.setAttribute('data-video-url', thumbnails[active].dataset.videoUrl);
      } else {
        this.imageTarget.setAttribute('data-video', thumbnails[active].dataset.video);
      }
      let div = this.imageTarget.parentNode.parentNode;
      div.style.height = `${div.dataset.height}px`;

      this.image_zoom_iconTarget.innerHTML = `
        <span class="fa-stack fa-2x">
          <i class="fa-solid fa-circle fa-stack-2x"></i>
          <i class="fa-solid fa-play fa-stack-1x fa-inverse"></i>
        </span>
      `
    } else {
      let iframe = this.productPictureWrapperTarget.querySelector("iframe");
      if(iframe) {
        iframe.remove();
      }
      let video = this.productPictureWrapperTarget.querySelector("video");
      if(video) {
        video.remove();
      }
      this.productPictureTarget.classList.remove('is-hidden');
      this.imageTarget.removeAttribute('data-video-url');

      this.image_zoom_iconTarget.innerHTML = `
        <span class="fa-stack fa-2x">
          <i class="fa-solid fa-circle fa-stack-2x"></i>
          <i class="fa-solid fa-search fa-stack-1x fa-inverse"></i>
        </span>
      `
    }

    thumbnails[active].classList.add('active');
    this.productPictureThumbnailsTarget.setAttribute("data-active", active);
    bullets[active].querySelector('svg').setAttribute("data-prefix", 'fas');

    this.imageTarget.src = bullets[active].dataset.thumbnail;
    this.imageTarget.dataset.image = bullets[active].dataset.image;
    this.imageTarget.alt = bullets[active].dataset.title;
  }

  showImage() {
    let iframe = this.productPictureWrapperTarget.querySelector("iframe");
    if(iframe) {
      iframe.remove();
    }
    let video = this.productPictureWrapperTarget.querySelector("video");
    if(video) {
      video.remove();
    }

    this.productVideoWrapperTarget.style.display = "block"
    this.productVideoWrapperTarget.style.justifyContent = "unset"

    if(event.target.dataset.videoUrl || event.target.dataset.video) {
      this.productPictureTarget.classList.add('is-hidden');

      let div = this.productPictureTarget.parentNode;
      if(event.target.dataset.videoUrl) {
        let iframe = document.createElement('iframe');
        iframe.src = event.target.dataset.videoUrl;
        iframe.title = event.target.dataset.name;
        iframe.frameborder = "0"
        iframe.style.margin = "auto"
        iframe.style.width = "100%"
        iframe.style.height = "60vh";
        div.appendChild(iframe);
      } else {
        let video = document.createElement('video');
        video.controls = true;
        video.setAttribute('controlsList', 'nodownload')
        video.src = event.target.dataset.video;
        video.style.maxHeight = "100%";

        this.productVideoWrapperTarget.style.display = "flex"
        this.productVideoWrapperTarget.style.justifyContent = "center"
        div.appendChild(video);
      }
    } else {
      this.productPictureTarget.classList.remove('is-hidden');
    }
    this.productPictureTarget.src = event.target.dataset.image;
    this.productPictureDescriptionTarget.innerHTML = event.target.alt;
    this.productPictureWrapperTarget.classList.remove('is-hidden');
    this.productPictureWrapperTarget.focus();

    let pz = new PinchZoom(this.productPictureTarget, {
      draggableUnzoomed: false,
      minZoom: 1,
    });
    pz.enable()

    const gesture = new Gesture(this.productPictureTarget, {
      diagonalSwipes: false
    });
    gesture.on('swiperight', (event) => {
      this.pictureNavigation("right");
    });
    gesture.on('swipeleft', (event) => {
      this.pictureNavigation("left");
    });
  }

  hideImage() {
    this.productPictureWrapperTarget.classList.add('is-hidden');
    let iframe = this.productPictureWrapperTarget.querySelector("iframe");
    if(iframe) {
      iframe.remove();
    }
    let video = this.productPictureWrapperTarget.querySelector("video");
    if(video) {
      video.remove();
    }
  }

  switchImage() {
    let img = event.target;

    if(event.target.dataset.url || event.target.dataset.video) {
      this.productPictureTarget.classList.add('is-hidden');
      if(event.target.dataset.url) {
        this.imageTarget.setAttribute('data-video-url', event.target.dataset.url);
      } else {
        this.imageTarget.setAttribute('data-video', event.target.dataset.video);
      }

      let div = this.imageTarget.parentNode.parentNode;
      div.style.height = `${div.dataset.height}px`;

      this.image_zoom_iconTarget.innerHTML = `
        <span class="fa-stack fa-2x">
          <i class="fa-solid fa-circle fa-stack-2x"></i>
          <i class="fa-solid fa-play fa-stack-1x fa-inverse"></i>
        </span>
      `
    } else {
      this.productPictureTarget.classList.remove('is-hidden');
      this.imageTarget.removeAttribute('data-video-url');
      this.imageTarget.removeAttribute('data-video');

      this.image_zoom_iconTarget.innerHTML = `
        <span class="fa-stack fa-2x">
          <i class="fa-solid fa-circle fa-stack-2x"></i>
          <i class="fa-solid fa-search fa-stack-1x fa-inverse"></i>
        </span>
      `
    }

    if(this.productPictureWrapperTarget.classList.contains('is-hidden')) {
      event.target.parentNode.querySelectorAll('svg').forEach((svg, i) => {
        svg.setAttribute("data-prefix", "far")
      });

      this.imageTarget.src = img.dataset.thumbnail;
      this.imageTarget.dataset.image = img.dataset.image;
      this.imageTarget.alt = img.dataset.title;

      event.target.querySelector('svg').setAttribute("data-prefix", "fas");

      this.productPictureThumbnailsTarget.querySelectorAll("img").forEach((img, i) => {
        if(i == event.target.dataset.index) {
          img.classList.add('active');
        } else {
          img.classList.remove('active');
        }
      });

      this.productPictureThumbnailsTarget.setAttribute("data-active", event.target.dataset.index);
    } else {
      this.productPictureThumbnailsTarget.querySelectorAll("img").forEach((img, i) => {
        img.classList.remove('active');
      });

      let iframe = this.productPictureWrapperTarget.querySelector("iframe");
      if(iframe) {
        iframe.remove();
      }
      let video = this.productPictureWrapperTarget.querySelector("video");
      if(video) {
        video.remove();
      }

      this.productVideoWrapperTarget.style.display = "block"
      this.productVideoWrapperTarget.style.justifyContent = "unset"

      if(event.target.dataset.videoUrl || event.target.dataset.video) {
        this.productPictureTarget.classList.add('is-hidden');

        let div = this.productPictureTarget.parentNode;
        if(event.target.dataset.videoUrl) {
          let iframe = document.createElement('iframe');
          iframe.src = event.target.dataset.videoUrl;
          iframe.title = event.target.dataset.name;
          iframe.frameborder = "0"
          iframe.style.margin = "auto"
          iframe.style.width = "100%"
          iframe.style.height = "60vh";
          div.appendChild(iframe);
        } else {
          let videoWrapper = document.createElement('div');
          let video = document.createElement('video');
          video.controls = true;
          video.setAttribute('controlsList', 'nodownload')
          video.src = event.target.dataset.video;
          video.style.maxHeight = "100%";

          this.productVideoWrapperTarget.style.display = "flex"
          this.productVideoWrapperTarget.style.justifyContent = "center"
          div.appendChild(video);
        }
      } else {
        this.productPictureTarget.classList.remove('is-hidden');
        this.imageTarget.removeAttribute('data-video-url');

        this.productPictureTarget.src = event.target.dataset.image;
        this.productPictureDescriptionTarget.textContent = event.target.alt;
      }
      event.target.classList.add('active');
    }
  }

  switchTab() {
    this.tabsTarget.querySelectorAll("a").forEach((a, i) => {
      if(a.dataset.target == event.target.dataset.target) {
        a.parentNode.classList.add('is-active');
      } else {
        a.parentNode.classList.remove('is-active');
      }
    });

    this.tabsContentTarget.querySelectorAll("div.tab-content").forEach((div, i) => {
      if(div.id == event.target.dataset.target) {
        div.classList.remove('is-hidden');
      } else {
        div.classList.add('is-hidden');
      }
    });

    window.sendAnalytics("view_item_details", {
      currency: this.currencyValue,
      items: [
        {
          item_id: this.itemIdValue,
          item_name: this.itemNameValue,
          price: this.priceValue,
          currency: this.currencyValue
        }
      ]
    });
  }

  toggleImageZoomIcon() {
    this.image_left_iconTarget.classList.toggle('is-hidden');
    this.image_zoom_iconTarget.classList.toggle('is-hidden');
    this.image_right_iconTarget.classList.toggle('is-hidden');
  }

  setColor() {
    let uuid = event.target.dataset.uuid;

    this.colorVariantTargets.forEach((btn, i) => {
      if(btn.dataset.uuid == uuid) {
        btn.classList.add('has-background-secondary-dark');
        this.inputUuidTarget.value = uuid;
      } else {
        btn.classList.remove('has-background-secondary-dark');
      }
    });
  }

  setSize() {
    let itemsController = this;
    let uuid = event.target.dataset.uuid;

    Rails.ajax({
      url: `/${itemsController.locale}/item/${uuid}`,
      type: "get",
      data: "",
      success: function(data) {
        if(data.description_long && data.description_long != '') {
          let div = document.querySelector("#description_long");
          div.innerHTML = data.description_long;
          div.classList.remove("is-hidden");
        } else {
          div.classList.add("is-hidden");
        }
        if(itemsController.hasPriceTarget) {
          if(data.price_with_vat) {
            if(data.price_with_discount) {
              let price_without_discount = data.price*(data.vat/100+1);
              itemsController.priceTarget.innerHTML = `
                <span class="is-size-6 has-text-weight-normal mr-3 mb-1">
                  <strike>
                    ${price_without_discount.toFixed(2)} ${I18n.t(`currencies.abbr.${itemsController.currency}`)}
                  </strike>
                </span><br>
                <span class="has-text-danger">
                  ${data.price_with_vat.toFixed(2)} ${I18n.t(`currencies.abbr.${itemsController.currency}`)}
                </span>`;
            } else {
              itemsController.priceTarget.textContent = `${data.price_with_vat.toFixed(2)} ${I18n.t(`currencies.abbr.${itemsController.currency}`)}`;
            }
            itemsController.spanPriceWithVatTarget.classList.remove('is-hidden');
          } else {
            itemsController.priceTarget.textContent = '';
            itemsController.spanPriceWithVatTarget.classList.add('is-hidden');
          }
        }
        if(data.with_stock) {
          let min = parseInt(itemsController.itemStockTarget.dataset.threshold);
          if(!min) {
            min = 0;
          }
          itemsController.itemStockTarget.classList.remove('has-text-success-dark', 'has-text-warning-dark', 'has-text-danger-dark');
          if(data.stock > min) {
            itemsController.itemStockTarget.classList.add('has-text-success-dark');
            itemsController.itemStockTarget.innerHTML = `<i class="fa-solid fa-circle-check"></i> ${I18n.t('item.in_stock')}`
            itemsController.buttonAddToCartTarget.disabled = false;
          } else if(data.stock <= min && data.stock > 0) {
            itemsController.itemStockTarget.classList.add('has-text-warning-dark');
            itemsController.itemStockTarget.innerHTML = `<i class="fa-solid fa-circle-check"></i> ${I18n.t('item.few_in_stock')}`
            itemsController.buttonAddToCartTarget.disabled = false;
          } else {
            itemsController.itemStockTarget.classList.add('has-text-danger-dark');
            itemsController.itemStockTarget.innerHTML = `<i class="fa-solid fa-circle-xmark"></i> ${I18n.t('item.currently_not_available')}`
            itemsController.buttonAddToCartTarget.disabled = true;
          }
          itemsController.itemStockTarget.classList.remove('is-hidden');
        } else {
          itemsController.itemStockTarget.classList.add('is-hidden');
        }
      },
      error: function(data) {}
    })

    this.sizeVariantTargets.forEach((btn, i) => {
      if(btn.dataset.uuid == uuid) {
        btn.classList.add('has-background-secondary-dark');
        this.buttonAddToCartTarget.setAttribute("data-uuid", uuid);
      } else {
        btn.classList.remove('has-background-secondary-dark');
      }
    });
  }

  checkQuantities() {
    if(this.unitStepsValue) {
      try {
        let d = Math.ceil(event.target.value / parseFloat(this.unitStepsValue));
        event.target.value = d * parseFloat(this.unitStepsValue);
      } catch {

      }
    }
  }

  incrementM2() {
    if(!this.hasM2QuantityTarget) return;

    const m2PerPack = parseFloat(this.m2QuantityTarget.dataset.m2PerPack);
    const currentM2 = parseFloat(this.m2QuantityTarget.value);
    const newM2 = currentM2 + m2PerPack;
    this.m2QuantityTarget.value = newM2.toFixed(2);
    this.autoSizeInput(this.m2QuantityTarget);
    this.updatePackageFromM2();
    this.updatePriceDisplay();
  }

  decrementM2() {
    if(!this.hasM2QuantityTarget) return;

    const m2PerPack = parseFloat(this.m2QuantityTarget.dataset.m2PerPack);
    const currentM2 = parseFloat(this.m2QuantityTarget.value);
    if (currentM2 > m2PerPack) {
      const newM2 = currentM2 - m2PerPack;
      this.m2QuantityTarget.value = newM2.toFixed(2);
      this.autoSizeInput(this.m2QuantityTarget);
      this.updatePackageFromM2();
      this.updatePriceDisplay();
    }
  }

  incrementPackage() {
    if(!this.hasPackageQuantityTarget) return;

    const currentPackages = parseInt(this.packageQuantityTarget.value);
    this.packageQuantityTarget.value = currentPackages + 1;
    this.autoSizeInput(this.packageQuantityTarget);
    this.updateM2FromPackage();
  }

  decrementPackage() {
    if(!this.hasPackageQuantityTarget) return;

    const currentPackages = parseInt(this.packageQuantityTarget.value);
    if (currentPackages > 1) {
      this.packageQuantityTarget.value = currentPackages - 1;
      this.autoSizeInput(this.packageQuantityTarget);
      this.updateM2FromPackage();
    }
  }

  updatePackageFromM2() {
    if(!this.hasM2QuantityTarget || !this.hasPackageQuantityTarget) return;

    const m2PerPack = parseFloat(this.m2QuantityTarget.dataset.m2PerPack);
    const m2Value = parseFloat(this.m2QuantityTarget.value);
    const packages = Math.round(m2Value / m2PerPack);
    this.packageQuantityTarget.value = packages;
    this.autoSizeInput(this.packageQuantityTarget);
  }

  updateM2FromPackage() {
    if(!this.hasM2QuantityTarget || !this.hasPackageQuantityTarget) return;

    const m2PerPack = parseFloat(this.m2QuantityTarget.dataset.m2PerPack);
    const packages = parseInt(this.packageQuantityTarget.value);
    const m2Value = packages * m2PerPack;
    this.m2QuantityTarget.value = m2Value.toFixed(2);
    this.autoSizeInput(this.m2QuantityTarget);
    this.updatePriceDisplay();
  }

  updateFromPackage() {
    this.updateM2FromPackage();
  }

  handlePackageInput() {
    if(this.hasPackageQuantityTarget) {
      this.autoSizeInput(this.packageQuantityTarget);
    }
  }

  handleM2Input() {
    if(!this.hasM2QuantityTarget) return;

    const m2PerPack = parseFloat(this.m2QuantityTarget.dataset.m2PerPack);
    const userM2Value = parseFloat(this.m2QuantityTarget.value);

    if(!userM2Value || userM2Value <= 0) {
      this.m2QuantityTarget.value = m2PerPack.toFixed(2);
      this.autoSizeInput(this.m2QuantityTarget);
      this.updatePackageFromM2();
      this.updatePriceDisplay();
      return;
    }

    const packagesNeeded = Math.ceil(userM2Value / m2PerPack);
    const roundedM2 = packagesNeeded * m2PerPack;

    this.m2QuantityTarget.value = roundedM2.toFixed(2);
    this.autoSizeInput(this.m2QuantityTarget);

    this.updatePackageFromM2();
    this.updatePriceDisplay();
  }

  handleM2InputResize() {
    if(this.hasM2QuantityTarget) {
      this.autoSizeInput(this.m2QuantityTarget);
    }
  }

  updatePriceDisplay() {
    if(!this.hasM2QuantityTarget || !this.hasPackagePriceTotalTarget) return;

    const m2Value = parseFloat(this.m2QuantityTarget.value);
    const pricePerM2 = parseFloat(this.m2QuantityTarget.dataset.pricePerM2);
    const regularPricePerM2 = parseFloat(this.m2QuantityTarget.dataset.regularPricePerM2);
    const hasDiscount = this.m2QuantityTarget.dataset.hasDiscount === 'true';

    const totalPrice = m2Value * pricePerM2;
    const regularTotalPrice = m2Value * regularPricePerM2;

    const labelSpan = this.packagePriceTotalTarget.querySelector('span.is-size-6');

    const existingPriceSpans = this.packagePriceTotalTarget.querySelectorAll('span:not(.is-size-6):not(.is-size-7)');
    existingPriceSpans.forEach(span => span.remove());

    if (hasDiscount) {
      const regularPriceSpan = document.createElement('span');
      regularPriceSpan.className = 'is-size-5 has-text-weight-normal mr-3';
      const strike = document.createElement('strike');
      strike.textContent = this.formatCurrency(regularTotalPrice);
      regularPriceSpan.appendChild(strike);

      const discountPriceSpan = document.createElement('span');
      discountPriceSpan.className = 'is-size-4 has-text-weight-bold has-text-danger';
      discountPriceSpan.setAttribute('data-items-target', 'selectedQuantityPrice');
      discountPriceSpan.textContent = this.formatCurrency(totalPrice);

      labelSpan.after(regularPriceSpan, discountPriceSpan);
    } else {
      const priceSpan = document.createElement('span');
      priceSpan.className = 'is-size-4 has-text-weight-bold';
      priceSpan.setAttribute('data-items-target', 'selectedQuantityPrice');
      priceSpan.textContent = this.formatCurrency(totalPrice);

      labelSpan.after(priceSpan);
    }
  }

  formatCurrency(value) {
    const amount = this.currency === 'CHF' ? swissAmount(value) : value.toFixed(2);
    if(this.hasCurrencyAbbrValue && this.hasCurrencyFormatValue) {
      if(this.currencyFormatValue == '%u %n') {
        return `${this.currencyAbbrValue} ${amount}`;
      } else {
        return `${amount} ${this.currencyAbbrValue}`;
      }
    }
    return amount + ' ' + this.currency;
  }

  showCartModal(itemData) {
    if(!this.hasCartModalTarget) return;

    if(this.hasModalTitleTarget) {
      if(itemData.isQuote) {
        this.modalTitleTarget.textContent = I18n.t('cart.item_added_to_quote');
      } else {
        this.modalTitleTarget.textContent = I18n.t('cart.item_added_to_cart');
      }
    }

    if(this.hasModalViewButtonTarget) {
      if(itemData.isQuote) {
        this.modalViewButtonTarget.textContent = I18n.t('cart.view_quote');
      } else {
        this.modalViewButtonTarget.textContent = I18n.t('cart.view_cart');
      }
    }

    if(this.hasModalItemNameTarget) {
      this.modalItemNameTarget.textContent = itemData.name;
    }
    if(this.hasModalItemSkuTarget) {
      this.modalItemSkuTarget.textContent = itemData.sku;
    }
    if(this.hasModalM2QuantityTarget) {
      this.modalM2QuantityTarget.textContent = itemData.m2Quantity;
    }
    if(this.hasModalPricePerM2Target) {
      this.modalPricePerM2Target.textContent = this.formatCurrency(itemData.pricePerM2);
    }
    if(this.hasModalTotalPriceTarget && itemData.vat) {
      this.modalTotalPriceTarget.innerHTML = `${I18n.t('item.total_item')}: ${this.formatCurrency(itemData.totalPrice)} <span class="is-size-7 has-text-weight-normal">${I18n.t('item.including_vat', { vat: itemData.vat })}</span>`;
    } else if(this.hasModalTotalPriceTarget) {
      this.modalTotalPriceTarget.textContent = this.formatCurrency(itemData.totalPrice);
    }
    if(this.hasModalItemImageTarget && itemData.image) {
      this.modalItemImageTarget.src = itemData.image;
    }

    this.cartModalTarget.classList.add('is-active');
  }

  closeModal() {
    if(this.hasCartModalTarget) {
      this.cartModalTarget.classList.remove('is-active');
    }
  }

  continueToCart() {
    const country = this.element.getAttribute("data-country") ||
                    document.querySelector("meta[name='country']")?.getAttribute('content') ||
                    'en';
    const locale = this.locale || 'en';
    window.location.href = `/${country.toLowerCase()}-${locale}/checkout`;
  }

  continueShopping() {
    this.closeModal();
  }

  autoSizeInput(input) {
    if(!input) return;

    requestAnimationFrame(() => {
      const measureSpan = document.createElement('span');
      measureSpan.style.visibility = 'hidden';
      measureSpan.style.position = 'absolute';
      measureSpan.style.whiteSpace = 'pre';
      measureSpan.style.padding = '0';
      measureSpan.style.margin = '0';
      measureSpan.style.border = 'none';

      const computedStyle = window.getComputedStyle(input);
      measureSpan.style.font = computedStyle.font;
      measureSpan.style.fontSize = computedStyle.fontSize;
      measureSpan.style.fontFamily = computedStyle.fontFamily;
      measureSpan.style.fontWeight = computedStyle.fontWeight;
      measureSpan.style.letterSpacing = computedStyle.letterSpacing;

      measureSpan.textContent = input.value || input.placeholder || '0';
      document.body.appendChild(measureSpan);

      const textWidth = measureSpan.offsetWidth;
      const minWidth = 70; // Minimum width in pixels

      const padding = 50; // Extra padding for input styling and controls
      const newWidth = Math.max(minWidth, textWidth + padding);

      input.style.width = newWidth + 'px';

      document.body.removeChild(measureSpan);
    });
  }
}
